<section class="user-profile-teaching-subpage profile-section" rel="teaching"
         [class.mobile]="deviceService.isMobile()"
         [class.tablet]="deviceService.isTablet()">
  <ng-container *ngIf="haveTeachingSubjects(); else noTeachingSubjects">
    <section class="section section-media" rel="teaching-about" [class.media]="isMediaPrepared">
      <app-title [title]="'user-profile.subjects-taught'"></app-title>

      <div class="section-body">
        <p *ngIf="teachingSubject" class="description">
          <span [innerHTML]="teachingSubject.description | striptags | nl2br" class="description"></span>
        </p>
        <ng-container *ngIf="isMediaPrepared">
          <ng-container *ngIf="isVideoFromYoutube; else recordedVideo">
            <iframe *ngIf="safeMediaUrl" [src]="safeMediaUrl"
                    allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    class="video">
            </iframe>
          </ng-container>

          <ng-template #recordedVideo>
            <video *ngIf="safeMediaUrl" class="video" controls playsinline height="100%" width="100%">
              <source [src]="safeMediaUrl" type='video/mp4'>
            </video>
          </ng-template>
        </ng-container>
      </div>
    </section>
  </ng-container>

  <section *ngIf="latestMeetingReviews.items.length && isAvailableReviews()" class="section" rel="latest-reviews">
    <app-title [title]="'user-service-card-full.titles.latest-reviews'"></app-title>
    <app-reviews-carousel [meetingReviews]="latestMeetingReviews.items"></app-reviews-carousel>
  </section>

  <ng-template [ngIf]="isAvailableServices()">
  <app-user-profile-classes-subpage [view]="'wide3'" [selectedSubjectId]="selectedSubjectId"
                                    (onChangeSubject)="setSubjectId($event)"
                                    (isCloseAllModals)="closeAllModals()"></app-user-profile-classes-subpage>
  </ng-template>

  <ng-template [ngIf]="isAvailableReviews()">
    <app-user-profile-feedback-subpage (loaded)="loaded.emit(true)"></app-user-profile-feedback-subpage>
  </ng-template>

  <ng-template [ngIf]="isMeVersion()">
    <app-user-profile-lessons-subpage *ngIf="isMe" [selectedSubjectId]="selectedSubjectId" (onChangeSubject)="setSubjectId($event)"></app-user-profile-lessons-subpage>
    <app-user-profile-about-subpage [limited]="true" [selectedSubjectId]="selectedSubjectId"
    [profile]="_profile"></app-user-profile-about-subpage>
  </ng-template>

  <ng-template #noTeachingSubjects>
    <section class="section">
      <app-title [title]="'user-profile.subjects-taught'"></app-title>
      <app-empty *ngIf="isMe" [empty]="emptyTeachingObj"></app-empty>
    </section>
  </ng-template>
</section>
